import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_carga_archivos/Administracion_carga_archivos.html?vue&type=template&id=173f4d8e&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_carga_archivos/Administracion_carga_archivos.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_carga_archivos/Administracion_carga_archivos.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_carga_archivos/Administracion_carga_archivos.css?vue&type=style&index=0&id=173f4d8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173f4d8e",
  null
  
)

export default component.exports